import React, { FC, useState } from 'react';
import { Typography } from '@mui/material';
import Container from '@/components/Container';
import BlockTypeUsageAnalyzer from '@/views/AnalyticsView/BlockTypeUsageAnalyzer';
import { useTranslation } from 'react-i18next';

export const AnalyticsView: FC = () => {
  const [useTab] = useState(0);
  const { t: tComponents } = useTranslation('components');

  return (
    <Container left fullWidth p={4} gap={2} top mt={0} column>
      <Typography variant='h3' sx={{ fontSize: 30 }}>
        {tComponents('AnalyticsView.Analysis')}
      </Typography>
      {/* <Tabs */}
      {/*  value={useTab} */}
      {/*  onChange={(_, newValue) => setUseTab(newValue)} */}
      {/*  textColor='secondary' */}
      {/*  TabIndicatorProps={{ style: { background: 'black' } }} */}
      {/*  sx={{ mb: 2 }}> */}
      {/*  <Tab label={tComponents('AnalyticsView.WhatPagesUseWhatModules')} value={0} /> */}
      {/* </Tabs> */}
      {useTab === 0 && <BlockTypeUsageAnalyzer />}
    </Container>
  );
};

export default AnalyticsView;
